const choices_data = [
    {
        "answer": "",
        "correct": true,
    },
    {
        "answer": "",
        "correct": false
    },
    {
        "answer": "",
        "correct": false
    },
    {
        "answer": "",
        "correct": false
    },
]

const config = {
    type: 'EVALUATION',
    component: "Sev02",
    portrait: "/img/container/S-EV-02.jpg",
    body: {
        question: "",
        time: '1',
        image: "https://placehold.co/600x400?text=Selecciona+o+arrastra+tu+imagen",
        choices: choices_data
    },
}

export { config }